import { gsap } from "gsap";
import { Sizes } from "../_app/cuchillo/core/Sizes";

export default class Tapa {
  position = {
    x: 0,
    y: 0
  }
  size = {
    width: 360 * Sizes.RATIO,
    height: 540 * Sizes.RATIO
  }
  opacity = 1;

  constructor() {}

  show(__call) {
    gsap.to(this, {opacity: .5, duration: 0.3, ease: 'power2.in', onComplete: __call});
  }

  hide() {
    gsap.to(this, {opacity: 0, duration: 0.3, ease: 'power2.in'});
  }

  draw(ctx) {
    ctx.globalAlpha = this.opacity;
    ctx.fillStyle = 'black';
    ctx.fillRect(this.position.x, this.position.y, this.size.width, this.size.height);
    ctx.globalAlpha = 1;
  }

  dispose() {
    // Restablecer propiedades a sus valores iniciales o null
    this.position = {
      x: 0,
      y: 0
    }
  }
}
